import { useEffect } from 'react'

import { useAuthContext } from './AuthContextProvider'
import useReturnToSessionStorage from './useReturnToSessionStorage'

const useSignIn = (): void => {
  const { isLoading, isSignedIn, signIn } = useAuthContext()

  const [, setReturnTo] = useReturnToSessionStorage()

  useEffect(() => {
    if (!isLoading && !isSignedIn) {
      setReturnTo(window.location.href)

      signIn()
    }
  }, [isLoading, isSignedIn, setReturnTo, signIn])
}

export default useSignIn
